import React from 'react';
import { Input, Row, Col } from 'antd';

const UserSearch = ({ usersData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = usersData.filter((record) => {
      const matchesUsername = record.username?.toLowerCase().includes(value.toLowerCase());
      const matchesFirstName = record.first_name?.toLowerCase().includes(value.toLowerCase());
      const matchesLastName = record.last_name?.toLowerCase().includes(value.toLowerCase());
      const matchesEmail = record.email?.toLowerCase().includes(value.toLowerCase());
      const matchesArea = record.area.name?.toLowerCase().includes(value.toLowerCase());
      const matchesRole =
        record.is_superuser
          ? 'superusuario'.includes(value.toLowerCase())
          : record.roles?.some(
              (role) => role.name?.toLowerCase().includes(value.toLowerCase())
            );
      const matchesLastLogin = record.last_login_app
        ? new Date(record.last_login_app)
            .toLocaleString('es-AR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            })
            .includes(value)
        : false;

      return (
        matchesFirstName || 
        matchesUsername ||
        matchesLastName ||
        matchesEmail ||
        matchesArea ||
        matchesRole ||
        matchesLastLogin
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(usersData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Usuarios"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default UserSearch;